module.exports = __webpack_public_path__ + "img/Doc05-20130617-001_16_June_2000.7ecde34f.jpg";